import axios from 'axios';
import * as actionTypes from '../constants/actions';

import baseUrl from '../utils/baseUrl';
let url = baseUrl + '/api/jury/';

let busy = false;

function action(type) {
	return { type: type };
};

function respond(json, type) {
	//console.log(type);
	return {
		type: type,
		payload: json,
	};
};


export function fetchJury(offset = 0, limit = 36, q = '') {
	let queryParams = {
		offset: offset,
		limit: limit,
		q: q,
	};

	if (busy) {
		return function(dispatch) {
			false;
		};
	}

	return function(dispatch) {
		busy = true;
		return axios({
			url: url,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: queryParams,
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.JURY_RECV_DATA));
			busy = false;
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.JURY_RECV_ERROR));
			console.log('jury - fetch error');
			console.log(response);
			busy = false;

			//dispatch(pushState(null, '/error'));
		});
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/jury.js
 **/